import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProcessoGrupoService } from '../services/processo-grupo.service';

@Injectable({
  providedIn: 'root',
})
export class ProcessoGrupoResolver implements Resolve<boolean> {
  constructor(private service: ProcessoGrupoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
